import React, { FC } from "react";
import { PostSummary } from "@app/models";
import { PressRelease } from "./components/press-release/PressRelease";
import { ShareLinks } from "./components/share-links/ShareLinks";
import { RelatedPublications } from "./components/related-publications/RelatedPublications";
import { VideoCardProps } from "./components/press-release/components/video-cards/components/video-card/VideoCard";

type Props = {
  articleTitle: string;
  relatedPosts: PostSummary[];
  pressReleaseVideos?: Pick<
    VideoCardProps,
    "title" | "excerpt" | "youtubeId"
  >[];
  pressReleaseFile?: string;
};

export const Footer: FC<Props> = ({
  articleTitle,
  relatedPosts,
  pressReleaseVideos,
  pressReleaseFile,
}) => {
  return (
    <>
      <PressRelease videos={pressReleaseVideos} file={pressReleaseFile} />
      <ShareLinks articleTitle={articleTitle} />
      {relatedPosts.length ? (
        <RelatedPublications posts={relatedPosts} />
      ) : null}
    </>
  );
};
